// extracted by mini-css-extract-plugin
module.exports = {"alertClass":"Alert_alertClass__1N6ii"};